module.exports = __webpack_public_path__ + "static/media/blog14.2c611e3f.svg";